import websocketService from 'src/services/websockets/websocketService';

export default {
  namespaced: true,
  
  state: {
    initialized: false,
    connected: false,
    channels: {}
  },
  
  mutations: {
    setInitialized(state, status) {
      state.initialized = status;
    },
    setConnected(state, status) {
      state.connected = status;
    },
    addChannel(state, channelName) {
      state.channels[channelName] = true;
    },
    removeChannel(state, channelName) {
      delete state.channels[channelName];
    },
    clearChannels(state) {
      state.channels = {};
    }
  },
  
  actions: {
    /**
     * Initialize the websocket service
     */
    initWebsockets({ commit, state }) {
      if (state.initialized) return;
      
      websocketService.init();
      commit('setInitialized', true);
      commit('setConnected', true);
      commit('addChannel', 'malawi-websockets');
    },
    
    /**
     * Clean up websocket connections
     */
    cleanupWebsockets({ commit }) {
      websocketService.cleanup();
      commit('setInitialized', false);
      commit('setConnected', false);
      commit('clearChannels');
    }
  },
  
  getters: {
    isInitialized: state => state.initialized,
    isConnected: state => state.connected,
    getChannels: state => Object.keys(state.channels)
  }
};